module.exports = __webpack_public_path__ + "static/img/member03.223aa7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member03.png
// module id = znQj
// module chunks = 0